import { getAccessToken, getUser } from '../auth/jwtAuth';
import { getOrCreateSession } from './awpSessionContext';

/**
 * Headers for every dash-api request.
 *
 * Primary auth: JWT Bearer token.
 * The legacy X-AWP-Session-Id / X-AWP-Session-Start headers are kept for
 * server-side tracing (they carry no auth weight).
 *
 * @returns {Record<string, string>} Plain object for fetch HeadersInit / Axios headers
 */
export function getAwpClientHeaders() {
    const { sessionId, sessionStart } = getOrCreateSession(getUser()?.uid);
    const headers = {
        'X-AWP-Session-Id': sessionId,
        'X-AWP-Session-Start': sessionStart,
    };

    const user = getUser();
    if (user?.uid) {
        headers['X-AWP-User-Id'] = user.uid;
    }

    const token = getAccessToken();
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const display = user?.displayName || user?.email;
    if (display) {
        headers['X-AWP-User-Display-Name'] = display;
    }

    return headers;
}
